/*!
 * @Author: leo
 * @Date: 2020-02-09 11:32:00
 * @Last Modified by: leo
 * @Last Modified time: 2020-02-09 11:32:00
 * @Instruduction: 公共服务接口
 */

import xhr from './xhr/index'
import { API_NIUMEI_HOST, HOST_PREFIX } from '@/config/env'
// eslint-disable-next-line
import { BaseParams, DeleteParams, DetailParams } from './index'

interface IUpdateBannerParams {
    img_name: string // 图片路径
}

interface IGetAppVersion {
    system: 'ios' | 'android'
}

interface IUpdateAppVersion {
    system: 'ios' | 'android'
    version: string
    content: string
    url: string
    is_approved: boolean
}

interface IGetMediaIndexBanner {}

interface IUpdateMediaIndexBanner {
    banner: string // banner 链接
    page_url: string // 活动页面链接
    is_show: boolean // 是否显示
}

interface IGetMediaCircleList {}

interface IGetMediaCircleDetail {
    id: number
}

interface ICreateMediaCircle {
    order: number // 顺序
    img: string // 图片链接
    app_img: string // app 图片链接
    title: string // 标题
    url: string // 页面链接
}

interface IUpdateMediaCircle {
    order: number // 顺序
    id: number // 编号
    img: string // 图片链接
    title: string // 标题
    url: string // 页面链接
}

interface IdeleteMediaCircle {
    id: number // 编号
}

interface IGetEventListParams {
    sort?: string // 排序
    page_index?: number // 第几页
    page_size?: number // 每页条数
}

interface IGetEventDetailParams {
    id: number // 事件 id
}

interface IUpdateEventParams {
    id: number // 事件 id
    title: string // 事件标题
    abstract: string // 摘要
    logo: string // logo 链接
    start_at: string // 开始时间
    end_at: string // 结束时间
}

interface ICombineEventParams {
    master_id: number // 主事件 id
    merge_ids: number[] // 被合并的事件 id 列表
}

interface IGetHotWordParams {}

interface IUpdateHotWordParams {
    pc_keywords: string[]
    app_keywords: string[]
}

interface IGetCommonWordParams {}

interface ICreateCommonWordParams {
    content: string
}

interface IUpdateCommonWordParams {
    id: number
    content: string
}

interface IDeleteCommonWordParams {
    id: number
}

interface ICreateStaffParams {
    name: string // 职位名
    type: number // 职位类型 1:技术
    province: string // 工作地点-省
    city: string // 工作地点-市
    duty: string // 工作职责
    require: string // 岗位要求
}

interface IDeleteStaffParams extends DeleteParams {}

interface IGetStaffDetailParams extends DetailParams {}

interface IUpdateStaffParams {
    id: number // 职位id
    name: string // 职位名
    type: number // 职位类型 1:技术
    province: string // 工作地点-省
    city: string // 工作地点-市
    duty: string // 工作职责
    require: string // 岗位要求
}

interface IGetStaffListParams {
    page_index?: number // 第几页
    page_size?: number // 每页条数
}

interface IGetInstituteListParams extends BaseParams {
    type?: number // 类型
}

interface IGetInstituteDetailParams extends DetailParams {}

interface ICreateInstituteParams {
    title: string // 标题
    type: number // 类型 1:研究报告 2:影响力周榜 3:影响力月榜 4:牛媒专访
    content: string // 内容
    organization: string // 组织
    writer: string // 作者
    cover_img: string // 封面图
    recommend: number // 是否推荐 0:否 1:是
    published_at: string // 发表时间
}

interface IUpdateInstituteParams {
    id: number // 编号
    title: string // 标题
    type: number // 类型 1:研究报告 2:影响力周榜 3:影响力月榜 4:牛媒专访
    content: string // 内容
    organization: string // 组织
    writer: string // 作者
    cover_img: string // 封面图
    recommend: number // 是否推荐 0:否 1:是
    published_at: string // 发表时间
}

interface IDeleteInstituteParams extends DeleteParams {}

interface IGetOperationListParams extends BaseParams {}

interface IGetOperationDetailParams extends DetailParams {}

interface ICreateOperationParams {
    title: string // 标题
    type: number // 类型 1:研究报告 2:影响力周榜 3:影响力月榜 4:牛媒专访
    content: string // 内容
    organization: string // 组织
    writer: string // 作者
    cover_img: string // 封面图
    recommend: number // 是否推荐 0:否 1:是
    published_at: string // 发表时间
}

interface IUpdateOperationParams {
    id: number // 编号
    title: string // 标题
    type: number // 类型 1:研究报告 2:影响力周榜 3:影响力月榜 4:牛媒专访
    content: string // 内容
    organization: string // 组织
    writer: string // 作者
    cover_img: string // 封面图
    recommend: number // 是否推荐 0:否 1:是
    published_at: string // 发表时间
}

interface IDeleteOperationParams extends DeleteParams {}

interface IGetApiListParams extends IGetOperationListParams {}

interface IGetApiDetailParams extends IGetOperationDetailParams {}

interface ICreateApiParams extends ICreateOperationParams {}

interface IUpdateApiParams extends IUpdateOperationParams {}

interface IDeleteApiParams extends IDeleteOperationParams {}

interface IGetBulletinListParams {
    page_index?: number // 第几页
    page_size?: number // 每页条数
}

interface IGetBulletinDetailParams extends DetailParams {}
interface ICreateBulletinParams {
    url?: string // 外链
    title: string // 标题
    abstract: string // 摘要
    content?: string // 内容
    published_at: string // 发表时间
}
interface IUpdateBulletinParams {
    id: number                          // 编号
    url?: string                        // 外链
    title: string                       // 标题
    abstract: string                    // 摘要
    content?: string                    // 内容
    published_at: string                // 发表时间
}

interface IDeleteBulletinParams extends DeleteParams {}

interface GetTypesParams {
    hot: number                 // 0:返回非热门（默认）;1:返回热门
}

class CommonService {
    /** 获取首页统计数据 */
    public async getRegion() {
        const result = await xhr({
            method: 'get',
            url: API_NIUMEI_HOST + HOST_PREFIX + '/region',
            params: null
        })
        return result
    }
    /** 获取线口领域 */
    public async getTypes(params?: GetTypesParams) {
        const result = await xhr({
            method: 'get',
            url: API_NIUMEI_HOST + HOST_PREFIX + '/news/types',
            params: params
        })
        return result
    }

    /** 获取行业分类 */
    public async getIndustry(params?: any) {
        const result = await xhr({
            method: 'get',
            // url: API_NIUMEI_HOST + HOST_PREFIX + '/company/industry/list',
            url: '/company/industry/list',
            params: params
        })
        return result
    }

    /** 获取牛媒网首页Banner图 */
    public async getHomeBanner() {
        const result = await xhr({
            method: 'get',
            url: '/home/banner',
            params: null
        })
        return result
    }
    /** 更新牛媒网首页Banner图 */
    public async updateHomeBanner(params: IUpdateBannerParams) {
        const result = await xhr({
            method: 'put',
            url: '/home/banner',
            params: params
        })
        return result
    }
    /** 获取APP最新版本信息 */
    public async getAppVersionInfo(params: IGetAppVersion) {
        const result = await xhr({
            method: 'get',
            url: '/app/newest_version',
            params: params
        })
        return result
    }

    /** 修改APP最新版本信息 */
    public async updateAppVersion(params: IUpdateAppVersion) {
        const result = await xhr({
            method: 'put',
            url: '/app/newest_version',
            params: params
        })
        return result
    }

    /** 获取牛媒首页活动 banner */
    public async getMediaIndexBanner(params?: IGetMediaIndexBanner) {
        const result = await xhr({
            method: 'get',
            url: '/activity/banner',
            params: params
        })
        return result
    }

    /** 修改牛媒首页活动 banner */
    public async updateMediaIndexBanner(params: IUpdateMediaIndexBanner) {
        const result = await xhr({
            method: 'put',
            url: '/activity/banner',
            params: params
        })
        return result
    }

    /** 获取传媒圈列表 */
    public async getMediaCircleList(params?: IGetMediaCircleList) {
        const result = await xhr({
            method: 'get',
            url: '/media_circle/list',
            params: params
        })
        return result
    }

    /** 获取传媒圈详情 */
    public async getMediaDetail(params?: IGetMediaCircleDetail) {
        const result = await xhr({
            method: 'get',
            url: '/media_circle',
            params: params
        })
        return result
    }
    /** 创建传媒圈 */

    public async createMediaCircle(params: ICreateMediaCircle) {
        const result = await xhr({
            method: 'post',
            url: '/media_circle',
            params: params
        })
        return result
    }
    /** 修改传媒圈 */

    public async updateMediaCircle(params: IUpdateMediaCircle) {
        const result = await xhr({
            method: 'put',
            url: '/media_circle',
            params: params
        })
        return result
    }
    /** 删除传媒圈 */

    public async deleteMediaCircle(params: IdeleteMediaCircle) {
        const result = await xhr({
            method: 'delete',
            url: '/media_circle',
            params: params
        })
        return result
    }
    /** 获取事件列表 */

    public async getEventList(params?: IGetEventListParams) {
        const result = await xhr({
            method: 'get',
            url: '/event/list',
            params: params
        })
        return result
    }
    /** 获取事件详情 */

    public async getEventDetail(params?: IGetEventDetailParams) {
        const result = await xhr({
            method: 'get',
            url: '/event',
            params: params
        })
        return result
    }
    /** 更新事件 */

    public async updateEvent(params: IUpdateEventParams) {
        const result = await xhr({
            method: 'put',
            url: '/event',
            params: params
        })
        return result
    }
    /** 合并事件 */

    public async combineEvent(params: ICombineEventParams) {
        const result = await xhr({
            method: 'post',
            url: '/event/merge',
            params: params
        })
        return result
    }

    /** 获取牛媒热搜 */

    public async getHotWord(params: IGetHotWordParams) {
        const result = await xhr({
            method: 'get',
            url: '/hot_search',
            params: params
        })
        return result
    }

    /** 编辑牛媒热搜 */

    public async updateHotWord(params: IUpdateHotWordParams) {
        const result = await xhr({
            method: 'put',
            url: '/hot_search',
            params: params
        })
        return result
    }

    /** 获取常用语列表 */

    public async getCommonWordList(params?: IGetCommonWordParams) {
        const result = await xhr({
            method: 'get',
            url: '/common_sentence/list',
            params: params
        })
        return result
    }

    /** 新增常用语列表 */

    public async createCommonWord(params: ICreateCommonWordParams) {
        const result = await xhr({
            method: 'post',
            url: '/common_sentence',
            params: params
        })
        return result
    }

    /** 获取常用语列表 */
    public async updateCommonWord(params: IUpdateCommonWordParams) {
        const result = await xhr({
            method: 'put',
            url: '/common_sentence',
            params: params
        })
        return result
    }

    /** 删除常用语列表 */
    public async deleteCommonWord(params: IDeleteCommonWordParams) {
        const result = await xhr({
            method: 'delete',
            url: '/common_sentence',
            params: params
        })
        return result
    }

    /** 获取职位列表 */
    public async getStaffList(params: IGetStaffListParams) {
        const result = await xhr({
            method: 'get',
            url: '/job/list',
            params: params
        })
        return result
    }

    /** 获取职位详情 */
    public async getStaffDetail(params: IGetStaffDetailParams) {
        const result = await xhr({
            method: 'get',
            url: '/job',
            params: params
        })
        return result
    }

    /** 新增职位 */
    public async createStaff(params: ICreateStaffParams) {
        const result = await xhr({
            method: 'post',
            url: '/job',
            params: params
        })
        return result
    }

    /** 更新职位 */
    public async updateStaff(params: IUpdateStaffParams) {
        const result = await xhr({
            method: 'put',
            url: '/job',
            params: params
        })
        return result
    }

    /** 删除职位 */
    public async deleteStaff(params: IDeleteStaffParams) {
        const result = await xhr({
            method: 'delete',
            url: '/job',
            params: params
        })
        return result
    }

    /** 获取数据报告列表 */
    public async getInstituteList(params: IGetInstituteListParams) {
        const result = await xhr({
            method: 'get',
            url: '/data_report/list',
            params: params
        })
        return result
    }

    /** 获取数据报告详情 */
    public async getInstituteDetail(params: IGetInstituteDetailParams) {
        const result = await xhr({
            method: 'get',
            url: '/data_report',
            params: params
        })
        return result
    }

    /** 新增数据报告 */
    public async createInstitute(params: ICreateInstituteParams) {
        const result = await xhr({
            method: 'post',
            url: '/data_report',
            params: params
        })
        return result
    }

    /** 更新数据报告 */
    public async updateInstitute(params: IUpdateInstituteParams) {
        const result = await xhr({
            method: 'put',
            url: '/data_report',
            params: params
        })
        return result
    }

    /** 删除数据报告 */
    public async deleteInstitute(params: IDeleteInstituteParams) {
        const result = await xhr({
            method: 'delete',
            url: '/data_report',
            params: params
        })
        return result
    }

    /** 获取媒体流量运营列表 */
    public async getOperationList(params: IGetOperationListParams) {
        const result = await xhr({
            method: 'get',
            url: '/operation/list',
            params: params
        })
        return result
    }

    /** 获取媒体流量运营详情 */
    public async getOperationDetail(params: IGetOperationDetailParams) {
        const result = await xhr({
            method: 'get',
            url: '/operation',
            params: params
        })
        return result
    }

    /** 新增媒体流量运营 */
    public async createOperation(params: ICreateOperationParams) {
        const result = await xhr({
            method: 'post',
            url: '/operation',
            params: params
        })
        return result
    }

    /** 更新媒体流量运营 */
    public async updateOperation(params: IUpdateOperationParams) {
        const result = await xhr({
            method: 'put',
            url: '/operation',
            params: params
        })
        return result
    }

    /** 删除媒体流量运营 */
    public async deleteOperation(params: IDeleteOperationParams) {
        const result = await xhr({
            method: 'delete',
            url: '/operation',
            params: params
        })
        return result
    }

    /** 获取Api列表 */
    public async getApiList(params: IGetApiListParams) {
        const result = await xhr({
            method: 'get',
            url: '/api/list',
            params: params
        })
        return result
    }

    /** 获取Api详情 */
    public async getApiDetail(params: IGetApiDetailParams) {
        const result = await xhr({
            method: 'get',
            url: '/api',
            params: params
        })
        return result
    }

    /** 新增Api */
    public async createApi(params: ICreateApiParams) {
        const result = await xhr({
            method: 'post',
            url: '/api',
            params: params
        })
        return result
    }

    /** 更新Api */
    public async updateApi(params: IUpdateApiParams) {
        const result = await xhr({
            method: 'put',
            url: '/api',
            params: params
        })
        return result
    }

    /** 删除Api */
    public async deleteApi(params: IDeleteApiParams) {
        const result = await xhr({
            method: 'delete',
            url: '/api',
            params: params
        })
        return result
    }

    /** 公告栏列表 */
    public async getBulletinList(params: IGetBulletinListParams) {
        const result = await xhr({
            method: 'get',
            url: '/bulletin/list',
            params: params
        })
        return result
    }

    /** 公告栏详情 */
    public async getBulletinDetail(params: IGetBulletinDetailParams) {
        const result = await xhr({
            method: 'get',
            url: '/bulletin',
            params: params
        })
        return result
    }

    /** 新增公告栏 */
    public async createBulletin(params: ICreateBulletinParams) {
        const result = await xhr({
            method: 'post',
            url: '/bulletin',
            params: params
        })
        return result
    }

    /** 更新公告栏 */
    public async updateBulletin(params: IUpdateBulletinParams) {
        const result = await xhr({
            method: 'put',
            url: '/bulletin',
            params: params
        })
        return result
    }

    /** 更新公告栏 */
    public async deleteBulletin(params: IDeleteBulletinParams) {
        const result = await xhr({
            method: 'delete',
            url: '/bulletin',
            params: params
        })
        return result
    }

    /** 媒体定制爬虫列表 */
    public getSpiderConfigList(params: any) {
        return xhr({
            method: 'get',
            url: '/spider/list',
            params: params
        })
    }

    /** 媒体定制爬虫详情配置 */
    public getSpiderConfigDetail(params: any) {
        return xhr({
            method: 'get',
            url: '/spider',
            params: params
        })
    }

    /** 创建媒体定制爬虫配置 */
    public createSpiderConfig(params: any) {
        return xhr({
            method: 'post',
            url: '/spider',
            params: params
        })
    }

    /** 更新媒体定制爬虫配置 */
    public updateSpiderConfig(params: any) {
        return xhr({
            method: 'put',
            url: '/spider',
            params: params
        })
    }

    /** 删除媒体定制爬虫配置 */
    public deleteSpiderConfig(params: any) {
        return xhr({
            method: 'delete',
            url: '/spider',
            params: params
        })
    }

    /** 重置媒体定制爬虫配置 */
    public resetSpiderConfig(params: any) {
        return xhr({
            method: 'post',
            url: '/spider/reset',
            params: params
        })
    }

    /** 牛媒研究研究 - 数据报告类型列表 */
    public getDataReportTypeList(params: any) {
        return xhr({
            method: 'get',
            url: '/data_report/types',
            params: params
        })
    }

    /** 反馈意见列表 */
    public getFeedbackList(params: any) {
        return xhr({
            method: 'get',
            url: '/feedback/list',
            params: params
        })
    }

    /** 反馈意见详情 */
    public getFeedbackDetail(params: any) {
        return xhr({
            method: 'get',
            url: '/feedback',
            params: params
        })
    }

    public updateFeedbackDetail(params: any) {
        return xhr({
            method: 'put',
            url: '/feedback',
            params: params
        })
    }

    /** 数据纠错列表 */
    public getDataCorrectionList(params: any) {
        return xhr({
            method: 'get',
            url: '/data_correction/list',
            params: params
        })
    }

    /** 反馈意见详情 */
    public getDataCorrectionDetail(params: any) {
        return xhr({
            method: 'get',
            url: '/data_correction',
            params: params
        })
    }

    /** 更新反馈意见详情 */
    public updateDataCorrectionDetail(params: any) {
        return xhr({
            method: 'put',
            url: '/data_correction',
            params: params
        })
    }

    /** 收录请求列表 */
    public getIncludeRequestList(params: any) {
        return xhr({
            method: 'get',
            url: '/include_request/list',
            params: params
        })
    }
    
    /** 收录请求详情 */
    public getIncludeRequestDetail(params: any) {
        return xhr({
            method: 'get',
            url: '/include_request',
            params: params
        })
    }

    /** 收录请求详情 */
    public updateIncludeRequestDetail(params: any) {
        return xhr({
            method: 'put',
            url: '/include_request',
            params: params
        })
    }

    /******** 牛媒研究院 ********/
    /** 获取文章类型列表 */
    getIArticleTypes(params: any) {
        return xhr({
            method: 'get',
            url: '/institute/article/type/list',
            params: params
        })
    }

    /** 修改文章类型 */
    updateIArticleType(params: any) {
        return xhr({
            method: 'put',
            url: '/institute/article/type',
            params: params
        })
    }

    /** 修改文章类型 */
    createIArticleType(params: any) {
        return xhr({
            method: 'post',
            url: '/institute/article/type',
            params: params
        })
    }

    /** 删除文章类型 */
    deleteIArticleType(params: any) {
        return xhr({
            method: 'delete',
            url: '/institute/article/type',
            params: params
        })
    }

    /** 文章列表 */
    getIArticleList(params: any) {
        return xhr({
            method: 'get',
            url: '/institute/article/list',
            params: params
        })
    }

    /** 文章详情 */
    getIArticle(params: any) {
        return xhr({
            method: 'get',
            url: '/institute/article',
            params: params
        })
    }

    /** 创建文章 */
    createIArticle(params: any) {
        return xhr({
            method: 'post',
            url: '/institute/article',
            params: params
        })
    }

    /** 修改文章 */
    updateIArticle(params: any) {
        return xhr({
            method: 'put',
            url: '/institute/article',
            params: params
        })
    }

    /** 删除文章 */
    deleteIArticle(params: any) {
        return xhr({
            method: 'delete',
            url: '/institute/article',
            params: params
        })
    }
}

// 实例化后导出，全局单例
export default new CommonService()
